export var Headers;
(function (Headers) {
    Headers["REQUEST_ID_HEADER"] = "X-Request-Id";
    Headers["CORRELATION_ID_HEADER"] = "X-Correlation-Id";
    Headers["CORRELATION_ID_STORAGE_KEY"] = "ctp-correlation-id";
})(Headers || (Headers = {}));
